import { Component, Input } from '@angular/core';
import { HomeConfig } from 'src/app/model/homeConfig';
import { environment } from 'src/environments/environment';
import { AppModeService } from 'src/app/services/app-mode.service';

@Component({
  selector: 'app-hero-video',
  templateUrl: './hero-video.component.html',
  styleUrls: ['./hero-video.component.css'],
})
export class HeroVideoComponent {
  imageUrl = environment.apiUrl;
  @Input() config!: HomeConfig;

  constructor(public readonly appModeService: AppModeService) {
    console.log();
  }
}
